import React from 'react';
import Typography from 'Components/Atoms/Typography';

export default function DescriptionPreview({ description }: { description?: string }) {
  const characters = Array.from(description ?? '');
  const preview = characters.length > 60 ? `${characters.slice(0, 60).join('').trimEnd()}…` : description;
  return <Typography color="subdued" variant="text-3" translation={null}>{preview}</Typography>;
}
